import React from "react";

import { ReactComponent as ArrowNextWhite } from "../../../assets/icons/arrowNextWhite.svg";
import { ReactComponent as ArrowNextBlack } from "../../../assets/icons/arrowNextBlack.svg";
import { typeOfPAF } from "../../../constants/typeOfPAF";

const PatientCategory = ({
  registerPatient,
  selectTypeOfPatient,
  isPharmacy,
  handleChangeCheckBox,
}) => {
  const createMarkup = () => {
    const html = `<div>I confirm that the patient has been notified that their personal
    data is used solely for the purpose of entering them into the
    Lenalidomide Pregnancy Prevention Programme and is processed by
    the marketing authorisation holder (MAH) of the lenalidomide
    product they receive, its third party service providers and any
    worldwide Affiliates the MAH may have, for the purposes of
    compliance with the Risk Management Plan legal obligations and for
    storage purposes. Third party service providers include, for
    example, the distributor of the lenalidomide product you receive.</div> 
    <br/>
    <div>Queries on how their personal data will be processed can be
    directed to the MAH in question, by consulting their publicly
    available information (e.g. on their website) which details how
    they process their personal data and provides a contact point for
    any queries in relation to their use of the patient's personal
    data.</div>
    `;
    return { __html: html };
  };
  return (
    <React.Fragment>
      <h1 className="select-category-txt">
        Please select the patient prescription authorization form
      </h1>

      <hr className="green-hr" />

      <div className="m-top-3 m-bot-3 min-height">
        <button
          className={
            "full " +
            (registerPatient?.patient_type === typeOfPAF.MALE
              ? "second-button"
              : "green-light-button")
          }
          onClick={() => selectTypeOfPatient(typeOfPAF.MALE)}
        >
          Male{" "}
          {registerPatient?.patient_type === typeOfPAF.MALE ? (
            <ArrowNextWhite />
          ) : (
            <ArrowNextBlack />
          )}
        </button>
        <button
          className={
            "full " +
            (registerPatient?.patient_type === typeOfPAF.WOMANOFCP
              ? "second-button"
              : "green-light-button")
          }
          onClick={() => selectTypeOfPatient(typeOfPAF.WOMANOFCP)}
        >
          Woman of Childbearing Potential{" "}
          {registerPatient?.patient_type === typeOfPAF.WOMANOFCP ? (
            <ArrowNextWhite />
          ) : (
            <ArrowNextBlack />
          )}
        </button>
        <button
          className={
            "full " +
            (registerPatient?.patient_type === typeOfPAF.WOMANOFNCP
              ? "second-button"
              : "green-light-button")
          }
          onClick={() => selectTypeOfPatient(typeOfPAF.WOMANOFNCP)}
        >
          Woman of Non-Childbearing Potential{" "}
          {registerPatient?.patient_type === typeOfPAF.WOMANOFNCP ? (
            <ArrowNextWhite />
          ) : (
            <ArrowNextBlack />
          )}
        </button>

        {isPharmacy && (
          <div className="custom-checkbox">
            <label
              htmlFor="confirm_patient_has_been_notified"
              className="dove-gray"
            >
              <span dangerouslySetInnerHTML={createMarkup()}></span>
              <input
                type="checkbox"
                id="confirm_patient_has_been_notified"
                name="confirm_patient_has_been_notified"
                checked={registerPatient.confirm_patient_has_been_notified || false}
                onChange={handleChangeCheckBox}
              />
              <span className="checkmark" />
            </label>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};
export default PatientCategory;
